export default __webpack_public_path__ + "static/media/012-backpack.f4f1bfca.png";